// HILDR — forflytningsplan: metode (kolonne/heli/til fots/…), takt-hastighet,
// avstand, peiling og ETA. Deterministisk — grunnlaget for ordregangen (OODA).
import { haversineKm, bearingDeg, compassSector } from './geo.js';
export const METHODS = {
    tilfots: { method: 'tilfots', label: 'Til fots', speedKmh: 4,
        konsept: 'Patruljeformasjon, tropp i kolonne med flankesikring. Lyddisiplin. Hvil 10 min/time.' },
    kolonne: { method: 'kolonne', label: 'Kolonnekjøring', speedKmh: 30,
        konsept: 'Marsjkolonne, 50 m avstand mellom kjøretøy, ledebil + haleavdeling. Trafikkvakter i kryss.' },
    kjoretoy: { method: 'kjoretoy', label: 'Kjøretøy (enkelt)', speedKmh: 40,
        konsept: 'Enkeltkjøretøy, høy hastighet, vekslende rute. Melder inn ved faslinjer.' },
    heli: { method: 'heli', label: 'Helikopter', speedKmh: 200,
        konsept: 'PZ→LZ-innflyging lav høyde, sikret landingssone, av-/pålessing < 90 s.' },
    bat: { method: 'bat', label: 'Fartøy', speedKmh: 35,
        konsept: 'Sjøverts forflytning, kystnær rute, ilandstigningspunkt sikret før anløp.' },
};
/** Planlegg forflytning fra→til med valgt metode. */
export function planMovement(from, to, method) {
    const spec = METHODS[method];
    const distanceKm = haversineKm(from, to);
    const brg = bearingDeg(from, to);
    const etaMin = Math.max(1, Math.ceil((distanceKm / spec.speedKmh) * 60));
    return {
        method, methodLabel: spec.label, distanceKm: Math.round(distanceKm * 100) / 100,
        bearingDeg: Math.round(brg), sector: compassSector(brg), speedKmh: spec.speedKmh, etaMin,
    };
}
//# sourceMappingURL=movement.js.map